import React from 'react';

import DayGround from '~/components/backgrounds/DayGround';
import Brand from '~/components/titles/Brand';
import { FONT_SIZES } from '~/constants/typography';
import FramedView from '~/components/FramedView';
import Divider from '~/components/flow/Divider';

import Account from './components/Account';
import Password from './components/Password';
import Delete from './components/Delete';

function Settings() {
  // Styling
  const settingsStyle = {
    width: '100%',
    fontSize: FONT_SIZES.text,
    textAlign: 'center' as const,
  };
  const containerStyle = {
    display: 'flex',
    minWidth: 350,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column' as const,
  };

  return (
    <div style={settingsStyle}>
      <DayGround>
        <div style={containerStyle}>
          <Brand topic="Settings" />
          <FramedView accent>
            <Account />
            <Divider />
            <Password />
            <Divider />
            <Delete />
          </FramedView>
        </div>
      </DayGround>
    </div>
  );
}

export default Settings;
